module.exports = __webpack_public_path__ + "img/trend-up-02.a2560bf5.svg";